import Nullstack from 'nullstack';
export default function IconArrowsMove({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrows-move",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M18 9l3 3l-3 3"
  }), "   ", Nullstack.element("path", {
    d: "M15 12h6"
  }), "   ", Nullstack.element("path", {
    d: "M6 9l-3 3l3 3"
  }), "   ", Nullstack.element("path", {
    d: "M3 12h6"
  }), "   ", Nullstack.element("path", {
    d: "M9 18l3 3l3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M12 15v6"
  }), "   ", Nullstack.element("path", {
    d: "M15 6l-3 -3l-3 3"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v6"
  }), " ");
}